var enterCode = "";
enterCode.toString();

if (document.querySelector('.pincode__button--clear')) {
  document.querySelector('.pincode__button--clear').addEventListener('click', (evnt) => {
    evnt.preventDefault();

    enterCode = '';
    document.querySelectorAll('.pincode__field').forEach((el) => el.classList.remove('is-active'));
    document.querySelector('input[name="pinlock"]').value = enterCode;

  });
}

if (document.querySelectorAll('.pincode__button').length) {
  document.querySelectorAll('.pincode__button').forEach((el) => {
    el.addEventListener('click', function(evnt) {
      evnt.preventDefault();
      if (parseInt(enterCode.length) == 4) {
        return;
      }

      var clickedNumber = this.innerHTML.toString();
      enterCode = enterCode + clickedNumber;

      var lengthCode = parseInt(enterCode.length);

      document.querySelector('input[name="pinlock"]').value = enterCode;
      document.querySelector('.pincode__field[data-index="' + lengthCode + '"]').classList.add("is-active");
    });
  });
}



// WEBPACK FOOTER //
// ./resources/assets/website/scripts/pincode-entry.js